import Vue from 'vue'
import Apig from './apig'

Vue.use(Apig, process.env.APIG)

export default new Apig()



// WEBPACK FOOTER //
// ./src/apig/index.js